
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    HARM: "HARM",
    ACID: "ACID",
    OZON: "OZON",
    GREEN: "GREEN",
    WASTE: "WASTE",
    BURN: "BURN",
    RECY: "RECY"
};
